import React from "react";
import { brl } from "../../lib/format";

const Pill = ({ children }) => (
  <span className="text-[11px] px-2 py-1 rounded-full bg-blue-50 border border-blue-200 text-blue-800">
    {children}
  </span>
);

const SectionTitle = ({ children }) => (
  <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold mb-1">
    {children}
  </div>
);

const RateBox = ({ label, value }) => (
  <div className="p-2 rounded bg-white border border-slate-200">
    <div className="text-slate-500">{label}</div>
    <div className="font-semibold">{brl(value)}</div>
  </div>
);

export function HouseDetailsView({ client }) {
  const c = client || {};
  const has =
    (c.has_pets !== null && c.has_pets !== undefined) ||
    c.property_subtype ||
    (c.bedrooms !== null && c.bedrooms !== undefined && c.bedrooms !== "") ||
    (c.bathrooms !== null && c.bathrooms !== undefined && c.bathrooms !== "") ||
    (c.square_feet !== null && c.square_feet !== undefined && c.square_feet !== "") ||
    (c.rooms_to_clean && c.rooms_to_clean.length) ||
    (c.cleaning_types && c.cleaning_types.length) ||
    (c.frequency_options && c.frequency_options.length) ||
    (c.preferred_days && c.preferred_days.length) ||
    (c.preferred_times && c.preferred_times.length) ||
    (c.supplies_provided !== null && c.supplies_provided !== undefined) ||
    (c.additional_services && c.additional_services.length) ||
    c.rate_weekly || c.rate_biweekly || c.rate_monthly || c.rate_other ||
    c.access_instructions;

  if (!has) return null;

  return (
    <div className="mt-5 p-4 rounded-xl border border-slate-200 bg-slate-50/50" data-testid="client-house-view">
      <div className="text-xs uppercase tracking-widest text-blue-700 font-semibold mb-3">
        🏠 Cadastro da Casa
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        {(c.has_pets !== null && c.has_pets !== undefined) && (
          <div>
            <SectionTitle>Pets</SectionTitle>
            <div>
              {c.has_pets ? "Sim" : "Não"}
              {c.has_pets && c.pet_names ? ` — ${c.pet_names}` : ""}
            </div>
          </div>
        )}
        {c.property_subtype && (
          <div>
            <SectionTitle>Tipo de Imóvel</SectionTitle>
            <div>{c.property_subtype}</div>
          </div>
        )}
        {(c.bedrooms || c.bathrooms || c.square_feet) && (
          <div className="md:col-span-2 flex flex-wrap gap-4">
            {c.bedrooms != null && c.bedrooms !== "" && (
              <div><SectionTitle>Quartos</SectionTitle><div>{c.bedrooms}</div></div>
            )}
            {c.bathrooms != null && c.bathrooms !== "" && (
              <div><SectionTitle>Banheiros</SectionTitle><div>{c.bathrooms}</div></div>
            )}
            {c.square_feet != null && c.square_feet !== "" && (
              <div><SectionTitle>Metragem</SectionTitle><div>{c.square_feet} sqft</div></div>
            )}
          </div>
        )}
        {c.rooms_to_clean && c.rooms_to_clean.length > 0 && (
          <div className="md:col-span-2">
            <SectionTitle>Cômodos a Serem Limpos</SectionTitle>
            <div className="flex flex-wrap gap-1.5">
              {c.rooms_to_clean.map((r) => <Pill key={r}>{r}</Pill>)}
            </div>
          </div>
        )}
        {c.cleaning_types && c.cleaning_types.length > 0 && (
          <div className="md:col-span-2">
            <SectionTitle>Tipo de limpeza</SectionTitle>
            <div className="flex flex-wrap gap-1.5">
              {c.cleaning_types.map((r) => <Pill key={r}>{r}</Pill>)}
            </div>
          </div>
        )}
        {c.frequency_options && c.frequency_options.length > 0 && (
          <div>
            <SectionTitle>Frequência</SectionTitle>
            <div className="flex flex-wrap gap-1.5">
              {c.frequency_options.map((r) => <Pill key={r}>{r}</Pill>)}
            </div>
          </div>
        )}
        {c.preferred_days && c.preferred_days.length > 0 && (
          <div>
            <SectionTitle>Dias Preferidos</SectionTitle>
            <div className="flex flex-wrap gap-1.5">
              {c.preferred_days.map((r) => <Pill key={r}>{r}</Pill>)}
            </div>
          </div>
        )}
        {c.preferred_times && c.preferred_times.length > 0 && (
          <div>
            <SectionTitle>Horário Preferido</SectionTitle>
            <div className="flex flex-wrap gap-1.5">
              {c.preferred_times.map((r) => <Pill key={r}>{r}</Pill>)}
            </div>
          </div>
        )}
        {(c.supplies_provided !== null && c.supplies_provided !== undefined) && (
          <div>
            <SectionTitle>Cliente Fornece Produtos?</SectionTitle>
            <div>{c.supplies_provided ? "Sim" : "Não"}</div>
          </div>
        )}
        {c.additional_services && c.additional_services.length > 0 && (
          <div className="md:col-span-2">
            <SectionTitle>Serviços Adicionais</SectionTitle>
            <div className="flex flex-wrap gap-1.5">
              {c.additional_services.map((r) => <Pill key={r}>{r}</Pill>)}
            </div>
          </div>
        )}
        {(c.rate_weekly || c.rate_biweekly || c.rate_monthly || c.rate_other) && (
          <div className="md:col-span-2">
            <SectionTitle>Tarifas (US$)</SectionTitle>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
              {c.rate_weekly ? <RateBox label="Semanal" value={c.rate_weekly} /> : null}
              {c.rate_biweekly ? <RateBox label="Quinzenal" value={c.rate_biweekly} /> : null}
              {c.rate_monthly ? <RateBox label="Mensal" value={c.rate_monthly} /> : null}
              {c.rate_other ? <RateBox label="Outra" value={c.rate_other} /> : null}
            </div>
          </div>
        )}
        {c.access_instructions && (
          <div className="md:col-span-2">
            <SectionTitle>Instruções da Chave / Acesso</SectionTitle>
            <div className="whitespace-pre-line p-2 rounded bg-amber-50 border border-amber-200 text-amber-900">
              {c.access_instructions}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
